module.exports = __webpack_public_path__ + "img/1996_L.d8849738.png";